import { Component, Input, HostBinding, ChangeDetectionStrategy } from '@angular/core'

@Component({
  selector: 'flo-live-geo-ip',
  templateUrl: './geo-ip.component.html',
  styleUrls: ['./geo-ip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GeoIPComponent {
  public txtDefault = 'Unavailable in your area'
  private _title = this.txtDefault

  @HostBinding('class.flo-footnote') clsFloFootnote = true

  @Input()
  @HostBinding('attr.title')
  get title() {
    return this._title
  }
  set title(val: string) {
    this._title = val || this.txtDefault
  }
}
